<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useSession } from '../auth';
import { trpc } from '../trpc';

const router = useRouter();
const session = useSession();
const user = computed(() => session.value?.data?.user);
const isLoading = computed(() => session.value?.isPending);

let redirecting = false;

// Returning users land on review when anything is due (the daily loop); otherwise on
// the library. A failed/blocked count check (e.g. no API key) falls back to the library
// so the key gate there can take over.
async function redirect() {
  if (isLoading.value || redirecting) return;
  if (!user.value) {
    router.replace('/sign-in');
    return;
  }
  redirecting = true;
  try {
    const { count } = await trpc.getDueCount.query();
    router.replace(count > 0 ? '/review' : '/learn');
  } catch {
    router.replace('/learn');
  }
}

onMounted(redirect);
watch([isLoading, user], redirect);
</script>

<template>
  <div class="min-h-screen bg-background" />
</template>
